/* TypeTopia — football shirt confetti on the face confetti page (v1.5)
   v1.5 (2026-10-28, Ally: "can all colour options be like this (not the colours the styling) - this is what we have on
   bunting so should be consistent ... black outline with a tick when selected"): each palette swatch carries its tick's
   colour (--tick, tickOn(): the bunting's rule); the look is assets/tt-shirt-confetti.css v1.3's.
   v1.4 (2026-10-26)
   v1.4 (Ally: "yea emojis on shirt"): an emoji in their name is on the shirt (assets/tt-shirt-data.js v1.4, in
   Microsoft's Fluent emoji: window.TTEmoji, which the section loads first). Its shapes are loaded as it's typed (or as a
   kept name comes back), then the pile and the big shirt are drawn again; till they're in, the line under the name
   doesn't call it a letter we haven't got, and adding waits.
   v1.3 (Ally: "when you come back ... you're back to the start, same with bunting & confetti"): their kit is kept a week
   in their browser (assets/tt-keep.js, record "shirtkit", loaded before this) and is back as they left it: name,
   number, pattern and every colour; kept again as the page is left.
   v1.2 (Ally: "this one doesnt need a make their confetti button, this page is better, just have add to basket & have
   those pieces on the right interact with mouse with one big piece that doesnt"): the page adds from the first screen
   (sections/tt-face-confetti.liquid v66.2); the pointer pushes the heap's pieces aside and each springs back, the big
   shirt stays put; on adding, the heap's pieces fly up into the basket (pile().toBasket) and a fresh heap drops in. The
   pieces' shadow is the site's hard one (Ally: "like the hard ones"): solid, straight down, the page blue made deeper.
   v1.1 (Ally: "yes add the outline"): the outline is automatic (assets/tt-shirt-data.js v1.3: one only where the
   lettering wouldn't read on the pattern); its automatic place wears it ("auto · navy"), struck through while there's none.
   assets/tt-shirt-confetti.js, with assets/tt-shirt-confetti.css. Loaded (deferred) by sections/tt-face-confetti.liquid
   (v66) only when its Product setting is the football shirt, after assets/tt-shirt-data.js (window.TTShirt: the print
   worker's own shirt engine, so the pieces on screen are the shirt it prints).

   Ally: "football shirt confetti possible?", "name & number yea", packs as face confetti's, on the face confetti page.
   The first screen's kit takes the photo upload's place: their name and number, then the wrap studio's kit (the pattern,
   the part to colour and its one palette, the "+" opening the shared custom colour card, assets/tt-colour-card). Beside
   it the pile: their shirt, cut out with its white edge, dropping into a heap and redrawn in place as they type (ALFIE 7,
   the product photo's, until they type a name or a number). Under the kit are the packs and add to basket (v1.2): the
   section adds the shirt as its one "face" (a canvas).

   window.TTShirtConf:
     mount(el, o)    the kit in el (.js-kit: .js-kname, .js-knum, .js-kmsg, .js-kitpats, .js-kitparts, .js-kitpal,
                     .js-kval); o.colourCard { js, css }
     check()         true when it can be ordered (a name or a number, both printable); else says why under the name and
                     puts the cursor there
     canvas(px)      their shirt, px across, see-through round it, no edge (the section's makeSprite adds the white edge)
     props()         the order line's props (TTShirt.toProps: Name, Number, Shirt colour, Second colour, Pattern, ...)
     KEYS            every prop it can set, so one left empty is taken off the line
     pile(box, o)    the first screen's pile on box's canvas; o.sprite(canvas, maxDim) -> { cv, w, h } (the section's
                     makeSprite), o.root (whose data-state says when the first screen is up); returns { sync,
                     toBasket(pt) } (pt: the basket's middle on screen; a Promise, settled as the last piece lands)
   Document event "tt:shirt-confetti" once it's loaded. */
(function (G) {
  "use strict";
  if (G.TTShirtConf) return;
  var T = G.TTShirt, D = document;
  if (!T) { console.warn("[tt-shirt-confetti] assets/tt-shirt-data.js isn't loaded"); return; }

  /* their kit, in TTShirt.kit's words ("" = the automatic colour); the wrap studio's starting kit */
  var KIT = { name: "", number: "", body: "red", second: "white", pattern: "plain", sleeves: "white", trim: "", ink: "", outline: "" };
  var SAMPLE = { name: "ALFIE", number: "7" };
  var PARTS = [["body", "shirt"], ["second", "2nd"], ["sleeves", "sleeves"], ["trim", "collar"], ["ink", "name"], ["outline", "outline"]];
  var QUICK = ["#12857f", "#c99a2e", "#8cc63f", "#c2185b", "#b39ddb", "#5d4037", "#6e7378", "#f3e9d2"];   /* (the studio's) */
  var KEYS = ["Name", "Number"].concat(Object.keys(T.PROPS).map(function (k) { return T.PROPS[k]; }));
  var MSG = { chars: "{letters} won’t print in this lettering.", long: "That’s a bit long: " + T.MAXNAME + " letters at most.",
              need: "Add their name or number first.", wait: "One moment: drawing their emoji…" };
  var part = "body", el = null, opts = {}, watchers = [];

  var qa = function (s) { return el ? [].slice.call(el.querySelectorAll(s)) : []; };
  var q = function (s) { return el ? el.querySelector(s) : null; };
  function hexOf(id) { return /^#/.test(id || "") ? id : ((T.COLOURS.filter(function (c) { return c.id === id; })[0]) || {}).hex || ""; }
  /* (v1.5) a swatch's tick, as the photo bunting's (its tickFor): #333 or white, whichever reads more on the colour
     (WCAG contrast; a gradient goes by its first colour) */
  function tickOn(c) {
    var m = /#([0-9a-f]{6}|[0-9a-f]{3})\b/i.exec(String(c || "")), h = m ? m[1] : "ffffff";
    if (h.length === 3) h = h.replace(/./g, "$&$&");
    var lum = function (x) { x /= 255; return x <= 0.03928 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4); };
    var v = parseInt(h, 16), l = 0.2126 * lum(v >> 16 & 255) + 0.7152 * lum(v >> 8 & 255) + 0.0722 * lum(v & 255), d = 0.0331;   /* (#333's) */
    return (Math.max(l, d) + 0.05) / (Math.min(l, d) + 0.05) >= 1.05 / (l + 0.05) ? "#333333" : "#ffffff";
  }
  function colourName(id) { var c = T.COLOURS.filter(function (x) { return x.id === id; })[0]; return c ? c.name.toLowerCase() : /^#/.test(id || "") ? "your own colour" : ""; }
  /* the kit as drawn: the sample's name and number until they've typed one */
  function drawn() {
    var k = {}; Object.keys(KIT).forEach(function (f) { k[f] = KIT[f]; });
    if (!T.cleanName(k.name).text && !k.number) { k.name = SAMPLE.name; k.number = SAMPLE.number; }
    return k;
  }
  function sig() { return JSON.stringify(drawn()) + "|" + (G.TTEmoji ? G.TTEmoji.version() : 0); }   /* (v1.4: drawn again once emoji are in) */
  function changed() { sync(); watchers.forEach(function (fn) { fn(); }); }
  /* the part being coloured: the second colour only while there's a pattern to have one */
  function curPart() { return part === "second" && KIT.pattern === "plain" ? "body" : part; }

  /* ── the kit's buttons, made once from the shirt engine's own lists ── */
  function build() {
    qa(".js-kitpats").forEach(function (box) {
      box.innerHTML = T.PATTERNS.map(function (p) {
        return '<button type="button" class="tt-kit__seg js-kpat" data-v="' + p.id + '" aria-pressed="false"><span>' + p.name.toLowerCase() + '</span></button>';
      }).join("");
    });
    qa(".js-kitparts").forEach(function (box) {
      box.innerHTML = PARTS.map(function (p) {
        return '<button type="button" class="tt-kit__seg js-kpart" data-part="' + p[0] + '" aria-pressed="false"><span>' + p[1] + '</span></button>';
      }).join("");
    });
    qa(".js-kitpal").forEach(function (box) {
      box.innerHTML = T.COLOURS.map(function (c) {
        return '<button type="button" class="tt-kit__col js-kcol" data-v="' + c.id + '" aria-label="' + c.name.toLowerCase() + '" aria-pressed="false" style="--sw: ' + c.hex + '; --tick: ' + tickOn(c.hex) + ';"></button>';
      }).join("") +
        '<button type="button" class="tt-kit__col tt-kit__col--custom js-kcustom" aria-label="your own colour" aria-haspopup="dialog" aria-pressed="false"></button>' +
        '<button type="button" class="tt-kit__col tt-kit__col--auto js-kcol" data-v="" aria-pressed="false"></button>';
    });
  }
  /* every button's state from the kit (the studio's syncKit) */
  function sync() {
    if (!el) return;
    var k = T.kit(drawn()), p = curPart(), v = KIT[p] || "";
    var patName = (T.PATTERNS.filter(function (x) { return x.id === KIT.pattern; })[0] || { name: "" }).name.toLowerCase();
    qa(".js-kpat").forEach(function (b) { b.setAttribute("aria-pressed", b.getAttribute("data-v") === KIT.pattern ? "true" : "false"); });
    qa(".js-kpart").forEach(function (b) {
      var w = b.getAttribute("data-part"), off = w === "second" && KIT.pattern === "plain";
      b.setAttribute("aria-pressed", w === p ? "true" : "false");
      b.setAttribute("aria-disabled", off ? "true" : "false");
      if (w === "second") { var s = b.querySelector("span"), t = off ? "2nd" : patName; if (s.textContent !== t) s.textContent = t; }
    });
    /* the palette: the part's colour ringed; its automatic place only for a part that has one ("as the shirt" for the
       sleeves; the outline's struck through while the automatic one is none) */
    var auto = p === "sleeves" || p === "trim" || p === "ink" || p === "outline";
    qa(".js-kcol").forEach(function (b) {
      var bv = b.getAttribute("data-v");
      b.setAttribute("aria-pressed", bv === v ? "true" : "false");
      if (bv) return;
      b.style.visibility = auto ? "" : "hidden";
      b.tabIndex = auto ? 0 : -1;
      b.setAttribute("aria-label", p === "sleeves" ? "as the shirt" : "auto");
      b.classList.toggle("is-none", p === "outline" && !k.outline);
      var bg = p === "sleeves" ? (KIT.pattern === "plain" ? hexOf(k.body) : "linear-gradient(135deg, " + hexOf(k.body) + " 50%, " + hexOf(k.second) + " 50%)")
        : p === "outline" && !k.outline ? "#fff" : hexOf(k[p]);
      if (b.style.getPropertyValue("--sw") !== bg) { b.style.setProperty("--sw", bg); b.style.setProperty("--tick", tickOn(bg)); }
    });
    var own = /^#/.test(v);
    qa(".js-kcustom").forEach(function (b) {
      b.classList.toggle("is-on", own);
      b.style.setProperty("--sw", own ? v : "#fff"); b.style.setProperty("--tick", tickOn(own ? v : ""));
      b.setAttribute("aria-pressed", own ? "true" : "false");
    });
    qa(".js-kval").forEach(function (o) {
      var t = o.getAttribute("data-k") === "style" ? patName : own ? "your own colour"
        : !v ? (p === "sleeves" ? "as the shirt" : "auto · " + (k[p] ? colourName(k[p]) : "none")) : colourName(v);
      if (o.textContent !== t) o.textContent = t;
    });
  }

  /* ── their name and number ── */
  function say(m) {
    var box = q(".js-kmsg"), nm = q(".js-kname");
    if (box && box.textContent !== (m || "")) box.textContent = m || "";
    if (nm) { if (m) nm.setAttribute("aria-invalid", "true"); else nm.removeAttribute("aria-invalid"); }
  }
  /* (v1.4) emoji in their name: their shapes, then the line under the name and the pile again */
  function pending() { return !!(T.emojiPending && T.emojiPending(KIT.name)); }
  function emojiSoon() {
    var M = G.TTEmoji, v = KIT.name;
    if (!M || !M.maybe(v)) return;
    M.need(v).then(function () { if (KIT.name === v) say(nameProblem()); changed(); }, function () { if (KIT.name === v) say(nameProblem()); });
  }
  function nameProblem() {
    var r = T.cleanName(KIT.name);
    if (r.ok || (r.reason === "chars" && pending())) return "";
    return r.reason === "long" ? MSG.long : MSG.chars.replace("{letters}", (r.bad || []).join(" "));
  }
  function check() {
    if (pending()) { emojiSoon(); say(MSG.wait); return false; }
    var m = nameProblem() || (!T.cleanName(KIT.name).text && !KIT.number ? MSG.need : "");
    say(m);
    if (m) { var nm = q(".js-kname"); if (nm) try { nm.focus({ preventScroll: true }); } catch (e) { nm.focus(); } }
    return !m;
  }

  /* ── the custom colour card (the bunting's), loaded the first time ── */
  var ccJob = null;
  function colourCard() {
    if (G.TTColourCard) return Promise.resolve(G.TTColourCard);
    if (!ccJob) {
      var cc = opts.colourCard || {};
      if (cc.css && !D.querySelector("link[data-tt-cc]")) {
        var l = D.createElement("link"); l.rel = "stylesheet"; l.href = cc.css; l.setAttribute("data-tt-cc", "");
        D.head.appendChild(l);
      }
      ccJob = new Promise(function (res, rej) {
        if (!cc.js) { rej(new Error("no colour card")); return; }
        var s = D.createElement("script"); s.src = cc.js; s.async = true;
        s.onload = function () { G.TTColourCard ? res(G.TTColourCard) : rej(new Error("colour card")); };
        s.onerror = function () { rej(new Error("colour card")); };
        D.head.appendChild(s);
      }).catch(function (e) { ccJob = null; throw e; });
    }
    return ccJob;
  }

  function mount(root, o) {
    if (!root || el) return;
    el = root; opts = o || {};
    build();
    var nm = q(".js-kname"), no = q(".js-knum");
    /* (v1.3) their kit from before, then kept as they leave */
    var K = !(G.Shopify && G.Shopify.designMode) && G.TTKeep, was = K ? K.get("shirtkit") : null;
    if (was && was.kit && typeof was.kit === "object") Object.keys(KIT).forEach(function (k) {
      var v = was.kit[k];
      if (typeof v !== "string" || v.length > (k === "name" ? 80 : 24)) return;      /* (v1.4: a name with emoji runs longer) */
      KIT[k] = k === "number" ? v.replace(/\D/g, "").slice(0, 2) : v;
    });
    if (nm && KIT.name && !nm.value) nm.value = KIT.name;
    if (no && KIT.number && !no.value) no.value = KIT.number;
    if (K) K.onLeave(function () { K.set("shirtkit", { kit: Object.assign({}, KIT), when: Date.now() }); });
    if (nm) {
      if (nm.value) KIT.name = nm.value;                      /* (a browser's restored value) */
      nm.addEventListener("input", function () { KIT.name = nm.value; emojiSoon(); say(nameProblem()); changed(); });
    }
    emojiSoon();                                              /* (v1.4: a kept name's emoji) */
    if (no) {
      if (no.value) KIT.number = no.value.replace(/\D/g, "").slice(0, 2);
      no.addEventListener("input", function () {
        var v = no.value.replace(/\D/g, "").slice(0, 2);
        if (v !== no.value) no.value = v;
        KIT.number = v; say(nameProblem()); changed();
      });
      no.addEventListener("keydown", function (e) { if (e.key === "Enter") { e.preventDefault(); no.blur(); } });   /* (done: the phone's keyboard goes) */
    }
    if (nm && no) nm.addEventListener("keydown", function (e) { if (e.key === "Enter") { e.preventDefault(); no.focus(); } });   /* (next: the number) */
    el.addEventListener("click", function (ev) {
      var t = ev.target && ev.target.closest ? ev.target : null;
      if (!t) return;
      var b = t.closest(".js-kpat"), w = t.closest(".js-kpart"), c = t.closest(".js-kcol"), x = t.closest(".js-kcustom");
      if (b) { KIT.pattern = b.getAttribute("data-v"); changed(); }
      else if (w && w.getAttribute("aria-disabled") !== "true") { part = w.getAttribute("data-part"); sync(); }
      else if (c) { KIT[curPart()] = c.getAttribute("data-v"); changed(); }
      else if (x) {
        var p = curPart(), v = KIT[p] || T.kit(drawn())[p] || "";
        colourCard().then(function (CC) {
          CC.open({ value: hexOf(v), title: "custom colour", action: "use", quick: QUICK, opener: x,
            onPick: function (hex) { KIT[curPart()] = String(hex).toLowerCase(); changed(); } });
        }, function () { say("That didn’t open — try again."); });
      }
    });
    sync();
  }

  /* ── their shirt as a picture ── */
  var BOX = null;
  function bounds() {                                           /* the shirt's outline, its ink included, in mm about its middle */
    if (BOX) return BOX;
    var S = T.silhouette(T.SHIRT_W), x0 = Infinity, x1 = -Infinity, y0 = Infinity, y1 = -Infinity;
    S.pts.forEach(function (p) { x0 = Math.min(x0, p[0]); x1 = Math.max(x1, p[0]); y0 = Math.min(y0, p[1]); y1 = Math.max(y1, p[1]); });
    BOX = { x0: x0 - S.edge, y0: y0 - S.edge, w: x1 - x0 + 2 * S.edge, h: y1 - y0 + 2 * S.edge };
    return BOX;
  }
  function canvas(px, kit) {
    var b = bounds(), k = (px || 600) / b.w, c = D.createElement("canvas");
    c.width = Math.ceil(b.w * k); c.height = Math.ceil(b.h * k);
    var g = c.getContext("2d");
    g.scale(k, k);
    T.shirt(g, kit || drawn(), -b.x0, -b.y0, T.SHIRT_W);
    return c;
  }
  function props() { return T.toProps(KIT); }

  /* ── the first screen's pile: their shirt, dropping into a heap ──
     A heap of places across the box's foot (rows getting shorter going up); the pieces drop into them one after another
     on a spring with a hair of overshoot, then every few seconds the piece that's lain longest drops out of the bottom
     and a fresh one drops into its place, so it never stops and never clutters. One picture serves every piece, made
     again only when the kit changes, so typing redraws the pile in place. In a tall box (computers) one big shirt drops
     in last over the heap and stays: a close-up of the kit as they choose it. It runs only while the first screen is up,
     on screen and in a visible tab; back on the first screen it drops in again. Reduced motion: all of it, still. */
  function spring(t, w, z) {                                    /* the share of the way still to go, t s after letting go */
    if (t <= 0) return 1;
    var wd = w * Math.sqrt(1 - z * z);
    return Math.exp(-z * w * t) * (Math.cos(wd * t) + z * w / wd * Math.sin(wd * t));
  }
  function seeded(n) { return function () { n = (n * 16807) % 2147483647; return (n - 1) / 2147483646; }; }
  function pile(box, o) {
    o = o || {};
    var cv = box && box.querySelector("canvas"), g = cv && cv.getContext && cv.getContext("2d");
    if (!g || typeof o.sprite !== "function") return null;
    var root = o.root || box, still = !!(G.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches);
    var W = 0, H = 0, dpr = 1, F = 80, spots = [], ps = [], sp = null, spKey = "", raf = 0, cycleT = 0, inView = true, dropped = false;
    var HF = 0, hero = null, hsp = null, hspKey = "";       /* a tall box (computers): one big shirt over the heap, a close-up as they choose */
    var now = function () { return (G.performance ? performance.now() : Date.now()) / 1000; };
    function up() { return root.getAttribute("data-state") === "upload"; }
    function live() { return inView && !D.hidden && up() && W > 0; }
    function heap() {
      var out = [], rnd = seeded(11), r = 0;
      while (r < 4) {
        var span = W * .9 - r * F * 1.1, n = Math.floor(span / (F * .76)), y = H - F * .42 - r * F * .5;
        if (n < 1 || y < F * .55) break;
        for (var i = 0; i < n; i++)
          out.push({ x: W / 2 + (i - (n - 1) / 2) * (span / n) + (rnd() - .5) * F * .2, y: y + (rnd() - .5) * F * .12,
                     rot: (rnd() - .5) * .9, row: r, key: rnd() });
        r++;
      }
      return out.sort(function (a, b) { return a.row - b.row || a.key - b.key; });   /* the foot first */
    }
    function size() {
      var r = box.getBoundingClientRect();
      W = r.width; H = r.height; dpr = Math.min(G.devicePixelRatio || 1, 2);
      cv.width = Math.max(1, Math.round(W * dpr)); cv.height = Math.max(1, Math.round(H * dpr));
      F = Math.max(52, Math.min(124, W * .21, H * .34));
      HF = H >= 380 ? Math.min(300, W * .46, H * .44) : 0;
      spots = heap(); sp = null; hsp = null;
      ps = ps.length ? spots.map(function (s) { return { s: s, born: -1e3 }; }) : [];   /* (resized: the heap as it lies) */
      if (hero) hero = { s: heroSpot(), born: -1e3 };
    }
    function heroSpot() { return { x: W / 2, y: Math.min(H * .4, H - F * 1.6 - HF * .3), rot: -.06 }; }
    /* the pictures: the section's own white edge (makeSprite), and under it the site's hard shadow (v1.2): the piece's own
       shape, solid, dropped straight down, in the page blue made deeper and more saturated (the thank-you insert's);
       one for every piece of the heap, one for the big shirt */
    var SHADE = "#4aaee8";
    function picture(size, drop) {
      var s = o.sprite(canvas(Math.round(size * dpr * 2)), Math.round(size * dpr)), d = Math.max(1, Math.round(drop * dpr));
      var c = D.createElement("canvas"); c.width = s.w; c.height = s.h + 2 * d;
      var x = c.getContext("2d");
      x.drawImage(s.cv, 0, 2 * d);
      x.globalCompositeOperation = "source-in"; x.fillStyle = SHADE; x.fillRect(0, 0, c.width, c.height);
      x.globalCompositeOperation = "source-over"; x.drawImage(s.cv, 0, d);
      return { cv: c, w: c.width / dpr, h: c.height / dpr };
    }
    function sprite() {
      var key = sig() + "|" + Math.round(F * dpr);
      if (!sp || key !== spKey) { sp = picture(F, Math.max(2.5, F * .035)); spKey = key; }
      return sp;
    }
    function heroSprite() {
      var key = sig() + "|" + Math.round(HF * dpr);
      if (!hsp || key !== hspKey) { hsp = picture(HF, Math.max(5, HF * .028)); hspKey = key; }
      return hsp;
    }
    /* (v1.2) the pointer pushes the heap's pieces aside, harder the faster it goes, and each springs back to its place
       with a hair of overshoot (its own offset, o); the big shirt never moves */
    var M = { x: 0, y: 0, vx: 0, vy: 0, on: false, t: 0 }, lastT = 0;
    function onMove(e) {
      if (still || !live()) { M.on = false; return; }
      var r = box.getBoundingClientRect(), x = e.clientX - r.left, y = e.clientY - r.top, t = now();
      var inside = x > -F && y > -F && x < W + F && y < H + F;
      if (M.on && inside) { var dt = Math.max(.008, t - M.t); M.vx = (x - M.x) / dt; M.vy = (y - M.y) / dt; } else { M.vx = 0; M.vy = 0; }
      M.x = x; M.y = y; M.t = t; M.on = inside;
      if (inside && stir()) kick();
    }
    function stir() {
      var R = F * 1.15, sp2 = Math.min(2400, Math.hypot(M.vx, M.vy)), hit = false;
      ps.forEach(function (p) {
        if (p.out || p.x0 != null && now() - p.born < 1.4) return;      /* (not while it's dropping in) */
        var q = p.o || { x: 0, y: 0, r: 0, vx: 0, vy: 0, vr: 0 };
        var dx = p.s.x + q.x - M.x, dy = p.s.y + q.y - M.y, d = Math.hypot(dx, dy);
        if (d > R) return;
        var f = 1 - d / R, ux = d > .5 ? dx / d : 0, uy = d > .5 ? dy / d : -1;
        q.vx += (ux * (70 + sp2 * .12) + M.vx * .08) * f;
        q.vy += (uy * (70 + sp2 * .12) + M.vy * .08) * f;
        q.vr += (ux * M.vy - uy * M.vx) / 2600 * f;
        p.o = q; hit = true;
      });
      return hit;
    }
    function settle(dt) {                                       /* the springs back, a step of dt s; true while any moves */
      var moving = false, cap = F * .9;
      ps.forEach(function (p) {
        var q = p.o; if (!q) return;
        q.vx += (-90 * q.x - 13 * q.vx) * dt; q.vy += (-90 * q.y - 13 * q.vy) * dt; q.vr += (-90 * q.r - 13 * q.vr) * dt;
        q.x += q.vx * dt; q.y += q.vy * dt; q.r += q.vr * dt;
        var L = Math.hypot(q.x, q.y); if (L > cap) { q.x *= cap / L; q.y *= cap / L; }
        if (Math.abs(q.x) + Math.abs(q.y) + Math.abs(q.vx) / 20 + Math.abs(q.vy) / 20 > .3 || Math.abs(q.r) + Math.abs(q.vr) / 20 > .003) moving = true;
        else p.o = null;
      });
      return moving;
    }
    function fresh(s, at) {
      var rnd = Math.random;
      return { s: s, born: at, x0: s.x + (rnd() - .5) * F * .7, y0: -F * (.7 + rnd() * .5) - (H - s.y) * .15, rot0: s.rot + (rnd() - .5) * 1.4 };
    }
    function dropIn(keepHero) {
      var t = now();
      ps = spots.map(function (s, i) { return still ? { s: s, born: -1e3 } : fresh(s, t + .15 + i * .07); });
      if (keepHero && hero) { /* (v1.2: after an add the big shirt stays where it is) */ }
      else if (HF) { var hs = heroSpot(); hero = still ? { s: hs, born: -1e3 } : { s: hs, born: t + .15 + spots.length * .07, x0: hs.x, y0: -HF * .7, rot0: hs.rot + .5 }; }
      else hero = null;
      dropped = true;
    }
    /* (v1.2) added to the basket: the heap's pieces fly up into it one after another, on a layer over the page (the box's
       canvas ends at its edge), shrinking as they go; then a fresh heap drops in under the big shirt */
    function toBasket(pt) {
      if (still || !W || !live() || !pt) return Promise.resolve();
      var r = box.getBoundingClientRect(), S = sprite(), t0 = now();
      var list = ps.filter(function (p) { return !p.out && t0 >= p.born; });
      if (!list.length) return Promise.resolve();
      var lw = G.innerWidth, lh = G.innerHeight, lay = D.createElement("canvas"), lg = lay.getContext("2d");
      lay.width = Math.round(lw * dpr); lay.height = Math.round(lh * dpr);
      lay.setAttribute("aria-hidden", "true");
      lay.style.cssText = "position:fixed;left:0;top:0;width:" + lw + "px;height:" + lh + "px;pointer-events:none;z-index:10000";
      D.body.appendChild(lay);
      var fl = list.sort(function (a, b) { return Math.hypot(a.s.x - W, a.s.y) - Math.hypot(b.s.x - W, b.s.y); }).map(function (p, i) {
        var q = p.o || { x: 0, y: 0, r: 0 };
        return { x0: r.left + p.s.x + q.x, y0: r.top + p.s.y + q.y, r0: p.s.rot + q.r, at: t0 + i * .03, spin: (Math.random() - .5) * 2.4 };
      });
      ps = ps.filter(function (p) { return list.indexOf(p) < 0; });   /* they've left the heap */
      draw();
      var DUR = .7;
      return new Promise(function (res) {
        (function step() {
          var t = now(), left = false;
          lg.setTransform(dpr, 0, 0, dpr, 0, 0); lg.clearRect(0, 0, lw, lh);
          fl.forEach(function (f) {
            var u = (t - f.at) / DUR;
            if (u >= 1) return;
            left = true; if (u < 0) u = 0;
            var e = u < .5 ? 2 * u * u : 1 - Math.pow(2 - 2 * u, 2) / 2, k = 1 - .8 * e;
            var x = f.x0 + (pt.x - f.x0) * e, y = f.y0 + (pt.y - f.y0) * e - Math.sin(Math.PI * e) * 70;
            lg.save(); lg.globalAlpha = u > .8 ? (1 - u) / .2 : 1; lg.translate(x, y); lg.rotate(f.r0 + f.spin * e); lg.scale(k, k);
            lg.drawImage(S.cv, -S.w / 2, -S.h / 2, S.w, S.h); lg.restore();
          });
          if (left) { requestAnimationFrame(step); return; }
          lay.remove(); res();
          setTimeout(function () { if (live()) { dropIn(true); kick(); schedule(); } else dropped = false; }, 250);
        })();
      });
    }
    function swapOne() {
      var t = now(), old = null;
      ps.forEach(function (p) { if (!p.out && (!old || p.born < old.born)) old = p; });
      if (!old) return;
      old.out = t;
      ps.push(fresh(old.s, t + .25));
    }
    function draw() {
      var t = now(), S = sprite(), busy = settle(Math.min(.034, Math.max(0, t - lastT)));
      lastT = t;
      g.setTransform(dpr, 0, 0, dpr, 0, 0);
      g.clearRect(0, 0, W, H);
      ps = ps.filter(function (p) { return !p.out || t - p.out < .6; });
      function one(p, S) {
        var s = p.s, a = 0, x = s.x, y = s.y, rot = s.rot, al = 1, dt = t - p.born;
        if (dt < 0) { busy = true; return; }
        if (dt < 1.4 && p.x0 != null) {
          a = spring(dt, 8.5, .8); busy = true;
          x += (p.x0 - s.x) * a; y += (p.y0 - s.y) * a; rot += (p.rot0 - s.rot) * a;
          al = Math.min(1, dt / .2);
        }
        if (p.out) { var u = t - p.out; y += 1400 * u * u; al = Math.max(0, 1 - u / .6); busy = true; }
        if (p.o) { x += p.o.x; y += p.o.y; rot += p.o.r; }   /* (v1.2: pushed aside by the pointer) */
        g.save(); g.globalAlpha = al; g.translate(x, y); g.rotate(rot);
        g.drawImage(S.cv, -S.w / 2, -S.h / 2, S.w, S.h);
        g.restore();
      }
      ps.forEach(function (p) { one(p, S); });
      if (hero && HF) one(hero, heroSprite());
      g.globalAlpha = 1;
      return busy;
    }
    function frame() { raf = 0; if (!W) return; if (draw() && live()) raf = requestAnimationFrame(frame); }
    function kick() { if (!raf && W && live()) raf = requestAnimationFrame(frame); }
    function schedule() {
      clearTimeout(cycleT);
      if (still || !live()) return;
      cycleT = setTimeout(function () { if (live()) { swapOne(); kick(); } schedule(); }, 2600);
    }
    function syncRun() {
      if (!up()) dropped = false;                               /* back on the first screen later: it drops in again */
      if (!live()) { clearTimeout(cycleT); if (raf) { cancelAnimationFrame(raf); raf = 0; } return; }
      if (!dropped) dropIn();
      if (still) draw(); else { kick(); schedule(); }
    }
    size();
    if (G.ResizeObserver) new ResizeObserver(function () { var w = W, h = H; size(); if (w !== W || h !== H) { if (dropped) draw(); syncRun(); } }).observe(box);
    if (G.IntersectionObserver) new IntersectionObserver(function (es) { inView = es[es.length - 1].isIntersecting; syncRun(); }).observe(box);
    D.addEventListener("visibilitychange", syncRun);
    new MutationObserver(syncRun).observe(root, { attributes: true, attributeFilter: ["data-state"] });
    watchers.push(function () { if (live() || still) { if (still || !raf) draw(); } });   /* the kit changed: the same heap, their shirt */
    G.addEventListener("pointermove", onMove, { passive: true });
    syncRun();
    return { sync: syncRun, toBasket: toBasket };
  }

  G.TTShirtConf = { mount: mount, check: check, canvas: canvas, props: props, pile: pile, KEYS: KEYS };
  try { D.dispatchEvent(new CustomEvent("tt:shirt-confetti")); } catch (e) {}
})(window);
